const original = {
  palette: {
    primary: {
      light: '#9672ff',
      main: '#6a35ff',
      dark: '#5a27e7',
    },
    secondary: {
      light: '#4f5e78',
      main: '#333333',
      dark: '#000000',
    },
    error: '#f14a59',
    warning: '#ff9f59',
    info: '#01d2fc',
    success: '#46d39a',
    text: {
      primary: '#111827', // #2d3958
      secondary: '#4b5563', // 7b88a8
      dark: '#182135',
      white: '#ffffff',
      disabled: '#bcc4da',
      link: '#3b82f6',
    },
    background: {
      default: '',
      contrast: '#182135',
      border: '#e6eaf5', // white-300
      white: '#ffffff',
      lightWhite: '#fefeff',
      lightBlue100: '#4ddffd',
      lightBlue200: '#01d2fc',
      pink100: '#f2b8ec',
      orange100: '#ffbc8b',
      whiteBg100: '#f8faff',
      whiteBg200: '#ebfbff',
      whiteBg300: '#f0fbf7',
      whiteBg400: '#fff7f2',
      whiteBg500: '#e4f4fb',
      whiteBg600: '#ecfcff',
      whiteBg700: '#fef1f2',
      whiteBg800: '#f3efff',
    },
  },
  typography: {
    h1: {
      fontSize: '1.2rem',
    },
    h2: {
      fontSize: '1rem',
    },
  },
  shape: {},
  container: {
    maxWidth: '1080px',
  },
  shadow: {
    card: '1px 1px 57px 72px rgb(61 96 132 / 5%)',
    image:
      '0px 7px 14px rgba(60, 65, 87, 0.12), 0px 3px 6px rgba(0, 0, 0, 0.09), inset 0px -1px 0px #e3e8ee',
  },
  spacing(n) {
    return n * 8;
  },
};
export default original;
